import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

export default createStore({
  state: {
    menuId: '', // 选中菜单
    tabList: [],
    token: '',
    menuList: [],
    tabActive: '',
    tabIndex: 0,
    userInfo:{}
  },
  getters: {

  },
  mutations: {
    setMenuId(state, menuId) {
      state.menuId = menuId
    },
    setTabList(state, tabList) {
      state.tabList = tabList
    },
    setToken(state, token) {
      state.token = token
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    setMenuList(state, menuList) {
      state.menuList = menuList
    },
    setTabActive(state, tabActive) {
      state.tabActive = tabActive
    },
    setTabIndex(state, tabIndex) {
      state.tabIndex = tabIndex
    }
  },
  actions: {

  },
  modules: {

  },
  plugins: [createPersistedState()]
})
